
import { Component, Vue, Watch } from 'vue-property-decorator';
import VueGridLayout from 'vue-grid-layout';
import WorkList from './components/indexServicer.vue';

import { getServiceWorkbench } from '@/api/workBench';
import { UserModule } from '@/store/modules/user';
import { returnLayout, returnPamars } from '@/utils/workBenchServicerUtil';
import { WorkbenchLayoutModules } from '@/store/modules/workBenchServicer';

@Component({
  name: 'Worktable',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    WorkList
  }
})

export default class extends Vue {
  private layoutData: any = ''

  private layout: any = [];
  private locLayout:any=JSON.parse(JSON.stringify(WorkbenchLayoutModules.getLayouts));

  private isDraggable = true
  private pamars:any={
    order_information_type: 1,
    unfinish_order_information_size: 10,

    department_order_ranking_type: 3,
    department_order_ranking_date_type: 1,
    department_order_ranking_size: 6,

    customer_ranking_size: 6,

    device_ranking_type: 1,

    fault_type_statistics_type: 1,
    fault_type_statistics_size: 10,
    fault_phenomenon_statistics_type: 1,
    fault_phenomenon_statistics_size: 10,

    engineer_ranking_type: 1,
    engineer_ranking_size: 10,

    order_bbs_information_size: 5
  }
  private toolsHeight = '100%';
  private minHt = window.innerHeight
  created() {
    this.layout = returnLayout();
    if (this.layout) {
      this.layout.map((item: any) => {
        let arr = this.locLayout.filter((i:any) => {
          return i.type === item.type;
        });
        if (arr && arr.length > 0) {
          item.isLocHave = true;
        }else{
          item.isLocHave = false;
        }
      });
    }
    this.pamars = {
      ...this.pamars,
      ...returnPamars(this.layout)
    };
    this.getServiceWorkbench(this.pamars);
  }
  mounted() {
    this.toolsHeight = (document.getElementsByClassName('tools-main')[0] as any).clientHeight || (document.getElementsByClassName('tools-main')[0] as any).offsetHeight;
    (document.getElementsByClassName('tools-left')[0] as any).style.height = (parseInt(this.toolsHeight) - 120) + 'px';
  }
  private getServiceWorkbench(ps:any) {
    let pamars:any = {
      ...ps
    };
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    getServiceWorkbench(pamars).then((res:any) => {
      if (res.data) {
        this.layoutData = res.data;
      }
    });
  }

  private allPamarsClick(val:any) {

  }

  private deleteMenuHandle(val: any) {
    this.layout = this.layout.map((item: any) => {
      if (item.type === val.type) {
        item.isLocHave = false;
      }
      return item;
    });
    const index = this.locLayout.map((item: any) => item.type).indexOf(val.type);
    this.locLayout.splice(index, 1);
  }
  private addMenuHandle(val: any) {
    this.layout = this.layout.map((item: any) => {
      if (item.type === val.type) {
        item.isLocHave = true;
      }
      return item;
    });
    this.locLayout.unshift(val);
  }
  private saveLayout() {
    WorkbenchLayoutModules.setLayout(this.locLayout);
    this.$router.go(-1);
  }
  private cancleSaveLayout() {
    this.$router.go(-1);
  }
}

